<template>

   <div class="content_support" v-show="proofLoginStatus">

      <h2 style="margin-bottom:25px; font-size: 22px;margin-top: 0px;">Ticket erstellen</h2>

      <div class="woocommerce-error" role="alert" v-if="summaryerror">Fehler. Das Ticket konnte nicht angelegt werden.</div>
      <div class="woocommerce-error" role="alert" v-if="fileextensionerror">Fehler. Das Ticket konnte nicht angelegt werden. Der Dateityp im Anhang ist nicht zulässig.</div>

      <div class="ticketformular">

         <!-- Prio -->
         <!-- Thema -->
         <!-- Betreff -->
         <!-- Nachricht -->
         <!-- Anhang -->

         <div class="inputfeld">
            <div class="col50_left">
               <label>Kategorie</label>
               <select v-model="ticket.thema" id="thema">
                  <option value="" disabled>Bitte wähle das Thema ...</option>
                  <option>obwyse Allgemein</option>
                  <option>obwyse Desktop</option>
                  <option>obwyse Mobile</option>
                  <option>Belegeimport</option>
                  <option>Belegverarbeitung</option>
                  <option>Belegexport</option>
                  <option>portinvoice</option>
                  <option>Vertrag</option>
                  <option>Upgrade Enterprise</option>
                  <option>Kundenportal</option>
               </select>
               <div class="errorm" v-if="error.thema"><label class="error" for="thema">Dieses Feld darf nicht leer sein.</label></div>
            </div>

            <div class="col50_right">
               <label>Priorität</label>
               <select v-model="ticket.prio" id="prio">
                  <option value="" disabled>Bitte wähle die Priorität ...</option>
                  <option value="1">Niedrig</option>
                  <option value="2">Mittel</option>
                  <option value="3">Hoch</option>
               </select>
               <div class="errorm" v-if="error.prio"><label class="error" for="prio">Dieses Feld darf nicht leer sein.</label></div>
            </div>
         </div>

         <div class="inputfeld">
            <label>Betreff</label>
            <input v-model="ticket.subject" type="text" id="subject">
            <div class="errorm" v-if="error.subject"><label class="error" for="subject">Dieses Feld darf nicht leer sein.</label></div>
         </div>

         <div class="inputfeld" style="height:250px;">
            <label>Nachricht</label>
            <textarea v-model="ticket.message" id="message"></textarea>
            <div class="errorm" v-if="error.message"><label class="error" for="message">Dieses Feld darf nicht leer sein.</label></div>
         </div>

         <div class="anhang">
            <label>Anhang 1</label>
            <input @change="handleImage1" class="custom-input" type="file" style="border:none;padding:0px;" />

            <hr style="margin-top:10px;margin-bottom:15px;" />

            <label>Anhang 2</label>
            <input @change="handleImage2" class="custom-input" type="file" style="border:none;padding:0px;" />
            <!-- <img :src="image" /> -->
         </div>

         <hr style="margin-top:10px;margin-bottom:25px;" />

         <ul class="buttons">
            <li>
               <router-link to="/" class="btn btn-primary grey" active-class="active_ticket" role="link">Abbrechen</router-link>
            </li>
            <li>
               <a href="#" class="btn btn-primary" @click="proofInput">Ticket erstellen</a>
            </li>
         </ul>

      </div>

   </div><!-- content_dashboard -->

</template>

<script>
// import AppFilterSwitches from './AppFilterSwitches';
// import AppGetPosts from './AppGetPosts';

export default {

	data() {
		return {
         wpData, // global data made available via wp_localize_script.
			image1: "",
         image2: "",
         prio: "",
         thema: "",
         message: "",
         subject: "",

         ticket: {
            thema: "",
            prio: "",
            message: "",
            subject: ""
         },

         anhang1: {
            base64: "",
            name: "",
            type: ""
         },
         anhang2: {
            base64: "",
            name: "",
            type: ""
         },

         allowedFormats: ["image/png", "image/jpg", "image/jpeg", "application/pdf", "image/tiff", "application/rtf", "application/zip", "application/gzip", "application/msexcel", "text/plain", "message/rfc822", "application/vnd.ms-outlook", "application/msword"],

         error: {
            thema: false,
            prio: false,
            message: false,
            subject: false           
         },
         summaryerror: false,
         fileextensionerror: false

		};
	},

   computed: {
      proofLoginStatus() {
         if (this.$store.getters.getZammadToken != "" && this.$store.getters.getZammadID != "" && this.$store.getters.isLoggedIn != "") {
            return true;
         } else {
            this.$router.push('/noAccess');
         }
      }
   },

	methods: {

      createTicket() {

         this.$store.commit('setLoadingWorkingScreen')

         var attachments = []

         if (this.anhang1.base64 != "" || this.anhang2.base64 != "") {

            if (this.anhang1.base64 != "") {
               if (this.allowedFormats.includes(this.anhang1.type)) {
                  var anhang1 = {
                     "filename": this.anhang1.name,
                     "data": this.anhang1.base64,
                     "mime-type": this.anhang1.type
                  }
                  attachments.push(anhang1)
               }
            }

            if (this.anhang2.base64 != "") {
               if (this.allowedFormats.includes(this.anhang2.type)) {
                  var anhang2 = {
                     "filename": this.anhang2.name,
                     "data": this.anhang2.base64,
                     "mime-type": this.anhang2.type
                  }
                  attachments.push(anhang2)
               }
            }

            var data = {
               'title': this.ticket.thema,
               'priority_id': this.ticket.prio,
               'subject': this.ticket.subject,
               'note': this.ticket.thema,
               'body': this.ticket.message,
               'user_email': this.$store.getters.getUserEmail,
               'zammad_token': this.$store.getters.getZammadToken,
               'zammad_id': this.$store.getters.getZammadID,
               'restURL': this.wpData.rest_url,
               'nonce': this.wpData.nonce,
               'attachments': attachments
            }

         } else {

            var data = {
               'title': this.ticket.thema,
               'priority_id': this.ticket.prio,
               'subject': this.ticket.subject,
               'note': this.ticket.thema,
               'body': this.ticket.message,
               'user_email': this.$store.getters.getUserEmail,
               'zammad_token': this.$store.getters.getZammadToken,
               'zammad_id': this.$store.getters.getZammadID,
               'restURL': this.wpData.rest_url,
               'nonce': this.wpData.nonce
            }

         }

         this.$store.dispatch('createTicket', data)
            .then(resp => {
               //console.log(resp)
               if (resp.data.code == 201) {
                  this.$store.commit('setStopLoadingWorkingScreen')
                  this.$router.push('/');
               } else {
                  this.$store.commit('setStopLoadingWorkingScreen')
                  this.summaryerror = true;
               }
            })
            .catch(err => {
               this.$store.commit('setStopLoadingWorkingScreen')
               this.summaryerror = true;
               console.log(err)
            }) 
      },

      proofInput() {
         this.error.thema = false;
         this.error.prio = false;
         this.error.message = false;
         this.error.subject = false;
         for (const [key, value] of Object.entries(this.ticket)) {
            if (value == "" && key == "thema") {
               this.error.thema = true;
            }
            if (value == "" && key == "prio") {
               this.error.prio = true;
            }
            if (value == "" && key == "subject") {
               this.error.subject = true;
            }
            if (value == "" && key == "message") {
               this.error.message = true;
            }
         }
         this.summaryerror = false;
         this.fileextensionerror = false;
         for (const [key, value] of Object.entries(this.error)) {
            if (value === true) {
               if (key == "anhang1" || key == "anhang2") {
                  this.fileextensionerror = true;
               } else {
                  this.summaryerror = true;
               }
            }
         }
         if (!this.summaryerror && !this.fileextensionerror) {
            this.createTicket();
         }
      },

      handleImage1(e) {
         this.anhang1.name = ""
         this.anhang1.type = ""
         this.anhang1.base64 = ""
         this.error.anhang1 = false
         const selectedImage = e.target.files[0]; // get first file
         if (selectedImage) {
            console.log(selectedImage);
            if (this.allowedFormats.includes(selectedImage.type) && selectedImage.size <= 5000000) {
               this.anhang1.name = selectedImage.name
               this.anhang1.type = selectedImage.type
               this.createBase64Image1(selectedImage);
            } else {
               this.error.anhang1 = true
            }
         }
      },
      handleImage2(e) {
         this.anhang2.name = ""
         this.anhang2.type = ""
         this.anhang2.base64 = ""
         this.error.anhang2 = false
         const selectedImage = e.target.files[0]; // get first file
         //console.log(selectedImage)
         if (selectedImage) {
            if (this.allowedFormats.includes(selectedImage.type) && selectedImage.size <= 5000000) {
               this.anhang2.name = selectedImage.name
               this.anhang2.type = selectedImage.type
               this.createBase64Image2(selectedImage);
            } else {
               this.error.anhang2 = true
            }
         }
      },
      createBase64Image1(fileObject) {
         const reader = new FileReader();
         reader.onload = (e) => {
            this.anhang1.base64 = e.target.result.split(',')[1];
         };
         reader.readAsDataURL(fileObject);
      },
      createBase64Image2(fileObject) {
         const reader = new FileReader();
         reader.onload = (e) => {
            this.anhang2.base64 = e.target.result.split(',')[1];
         };
         reader.readAsDataURL(fileObject);
      }

	}
};
</script>

<style scoped>

.ticketformular ul.buttons li {
   display: inline-block;
   margin-right: 8px;
}

.ticketformular .inputfeld {
   height: 85px;
   font-family: 'Roboto', sans-serif;
}

.ticketformular .col50_left {
    float: left;
    width: 47.5%;
    margin-right: 2.5%;
}

.ticketformular .col50_right {
    float: left;
    width: 47.5%;
    margin-left: 2.5%;
}

.ticketformular label, .ticketformular input, .ticketformular textarea, .ticketformular select {
   display: block;
   font-family: 'Roboto', sans-serif;
}

.ticketformular input:focus, .ticketformular textarea:focus, .ticketformular select:focus {
   border: 1px solid #272727;
   outline: none;
}

.ticketformular input {
background-color: #ffffff;
  border: 1px solid #cccccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  line-height: 20px;
  padding: 7px;
  width: 100%;
  font-size: 15px;
  font-family: 'Roboto', sans-serif;
  color: #272727;
}

.ticketformular textarea {
background-color: #ffffff;
  border: 1px solid #cccccc;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  line-height: 20px;
  padding: 7px;
  width: 100%;
  font-size: 15px;
  min-height: 200px;
  font-family: 'Roboto', sans-serif;
  color: #272727;
}

.ticketformular select {
width: 100%;
  height: 36px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  color: #272727 !important;
  line-height: 36px !important;
  font-size: 15px;
  padding-left: 7px;
  font-family: 'Roboto', sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/components/AppCustomSearch.vue